import { deleteTaggingEnrollment } from '../api/spm';
export default async (logger) => {
    return await deleteTaggingEnrollment({}, logger);
};
